import axios from "axios";
import config from "../../config"; // Ajusta la ruta según tu estructura

const baseUrl = config.baseUrl;

// Función para reemplazar valores nulos por '-'
const replaceNullWithDash = (value) =>
  value === null || value === undefined ? "-" : value;

// Función para obtener datos del mapa de Colombia
const getMapColombiaSostenibilidad = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/mapColombiaSostenibilidad`
    );
    const data = response.data.data; // Ajusta según el formato de respuesta
    const processedData = data.map((depto) => ({
      id: depto.codLib,
      idCodInterno: depto.oid,
      nameFusion: depto.nameFusion,
      value: replaceNullWithDash(depto.listaProyectos),
      color: "#4275af", // Color base de la región
      hoverBorderThickness: "2", // Grosor del borde en hover
      detalleText: `
  <div style="
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    word-wrap: break-word;
  ">

    <!-- Título del departamento -->
    <div style="background: linear-gradient(135deg, #042956 0%, #4275af 100%); 
                color: white; 
                padding: 20px; 
                border-radius: 8px; 
                margin-bottom: 20px; 
                box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                text-align: center;">
      <h2 style="margin: 0; font-size: 28px; font-weight: 600;">
        ${depto.departamento}
      </h2>
    </div>

    <!-- Cards de Indicadores Totales -->
    <div style="
      display: grid; 
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); 
      gap: 15px; 
      margin-bottom: 25px;
      width: 100%;
      box-sizing: border-box;
    ">

      <!-- Total Municipios -->
      <div style="
        background: white; 
        border-radius: 8px; 
        padding: 20px; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.1); 
        border-left: 4px solid #2196F3;
        text-align: center;
        max-width: 100%;
      ">
        <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                    display: flex; align-items: center; justify-content: center; margin: 0 auto 10px;">
          <span style="font-size: 20px;">🏛️</span>
        </div>
        <p style="margin: 0; font-size: 12px; color: #666; text-transform: uppercase;">MUNICIPIOS</p>
        <h3 style="margin: 8px 0 0; font-size: 20px; color: #042956; font-weight: 600;">
          ${depto.listaMunicipios.length || 0}
        </h3>
      </div>

      <!-- Total Proyectos -->
      <div style="
        background: white; 
        border-radius: 8px; 
        padding: 20px; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.1); 
        border-left: 4px solid #2196F3;
        text-align: center;
        max-width: 100%;
      ">
        <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                    display: flex; align-items: center; justify-content: center; margin: 0 auto 10px;">
          <span style="font-size: 20px;">📊</span>
        </div>
        <p style="margin: 0; font-size: 12px; color: #666; text-transform: uppercase;">PROYECTOS</p>
        <h3 style="margin: 8px 0 0; font-size: 20px; color: #042956; font-weight: 600;">
          ${depto.listaProyectos.length || 0}
        </h3>
      </div>

      <!-- Total Grupos Territoriales -->
      <div style="
        background: white; 
        border-radius: 8px; 
        padding: 20px; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.1); 
        border-left: 4px solid #2196F3;
        text-align: center;
        max-width: 100%;
      ">
        <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                    display: flex; align-items: center; justify-content: center; margin: 0 auto 10px;">
          <span style="font-size: 20px;">👥</span>
        </div>
        <p style="margin: 0; font-size: 12px; color: #666; text-transform: uppercase;">GRUPOS TERRITORIALES</p>
        <h3 style="margin: 8px 0 0; font-size: 20px; color: #042956; font-weight: 600;">
          ${depto.total_grupo_territorial || 0}
        </h3>
      </div>

      <!-- Total Participantes -->
      <div style="
        background: white; 
        border-radius: 8px; 
        padding: 20px; 
        box-shadow: 0 2px 8px rgba(0,0,0,0.1); 
        border-left: 4px solid #2196F3;
        text-align: center;
        max-width: 100%;
      ">
        <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                    display: flex; align-items: center; justify-content: center; margin: 0 auto 10px;">
          <span style="font-size: 20px;">🤝</span>
        </div>
        <p style="margin: 0; font-size: 12px; color: #666; text-transform: uppercase;">ORGANIZACIONES</p>
        <h3 style="margin: 8px 0 0; font-size: 20px; color: #042956; font-weight: 600;">
          ${depto.total_organizaciones || 0}
        </h3>
      </div>
    </div>

    <!-- Card de Participantes -->
    <div style="
      background: white; 
      border-radius: 8px; 
      padding: 20px; 
      box-shadow: 0 2px 8px rgba(0,0,0,0.1); 
      border-left: 4px solid #FF9800;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    ">
      <div style="display: flex; align-items: center; margin-bottom: 15px;">
        <div style="width: 40px; height: 40px; background: #fff3e0; border-radius: 50%; 
                    display: flex; align-items: center; justify-content: center; margin-right: 12px;">
          <span style="font-size: 20px;">🤝</span>
        </div>
        <h5 style="margin: 0; font-size: 18px; color: #042956; font-weight: 600;">Participantes</h5>
      </div>

   <div style="
  display: grid; 
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); 
  gap: 15px;
  width: 100%;
">
  ${
    depto.detalleParticipantes
      ? (() => {
          const hombres = depto.detalleParticipantes.hombres || 0;
          const mujeres = depto.detalleParticipantes.mujeres || 0;
          const total = depto.detalleParticipantes.total || 0;

          const porcentajeHombres =
            total > 0 ? ((hombres / total) * 100).toFixed(1) + "%" : "0%";
          const porcentajeMujeres =
            total > 0 ? ((mujeres / total) * 100).toFixed(1) + "%" : "0%";

          return `
            <div style="text-align: center; padding: 15px; background: linear-gradient(135deg, #2196F3 0%, #42A5F5 100%); border-radius: 8px;">
              <div style="font-size: 24px;">👨</div>
              <h3 style="margin: 0; font-size: 26px; color: white;">${hombres}</h3>
              <p style="margin: 0; color: white;">Hombres</p>
              <p style="margin: 0; color: #e0f7fa; font-size: 14px;">${porcentajeHombres}</p>
            </div>

            <div style="text-align: center; padding: 15px; background: linear-gradient(135deg, #E91E63 0%, #EC407A 100%); border-radius: 8px;">
              <div style="font-size: 24px;">👩</div>
              <h3 style="margin: 0; font-size: 26px; color: white;">${mujeres}</h3>
              <p style="margin: 0; color: white;">Mujeres</p>
              <p style="margin: 0; color: #f8bbd0; font-size: 14px;">${porcentajeMujeres}</p>
            </div>

            <div style="text-align: center; padding: 15px; background: linear-gradient(135deg, #FF9800 0%, #FFB74D 100%); border-radius: 8px;">
              <div style="font-size: 24px;">👥</div>
              <h3 style="margin: 0; font-size: 26px; color: white;">${total}</h3>
              <p style="margin: 0; color: white;">Total</p>
            </div>
          `;
        })()
      : '<p style="color: #999; text-align: center;">Sin información</p>'
  }
</div>

    </div>

    <!-- Grid de información -->
    <div style="
      display: grid; 
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); 
      gap: 20px; 
      margin: 30px 0;
      width: 100%;
    ">

      <!-- Municipios -->
      <div style="background: white; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-left: 4px solid #4275af;">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                      display: flex; align-items: center; justify-content: center; margin-right: 12px;">
            <span style="font-size: 20px;">📍</span>
          </div>
          <h5 style="margin: 0; font-size: 18px; color: #042956; font-weight: 600;">Municipios</h5>
        </div>
        <div style="max-height: 250px; overflow-y: auto;">
          <ul style="list-style: none; padding: 0; margin: 0;">
            ${
              depto.listaMunicipios?.length
                ? depto.listaMunicipios
                    .map(
                      (m) =>
                        `<li style="padding: 8px 12px; background: #f8f9fa; border-radius: 4px; border-left: 3px solid #4275af; margin-bottom: 6px;">${m}</li>`
                    )
                    .join("")
                : '<p style="color: #999; font-style: italic;">Sin información</p>'
            }
          </ul>
        </div>
      </div>

      <!-- Organizaciones -->
      <div style="background: white; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-left: 4px solid #9C27B0;">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                      display: flex; align-items: center; justify-content: center; margin-right: 12px;">
            <span style="font-size: 20px;">📍</span>
          </div>
          <h5 style="margin: 0; font-size: 18px; color: #042956; font-weight: 600;">Organizaciones</h5>
        </div>
        <div style="max-height: 250px; overflow-y: auto;">
          <ul style="list-style: none; padding: 0; margin: 0;">
            ${
              depto.listaOrganizaciones?.length
                ? depto.listaOrganizaciones
                    .map(
                      (m) =>
                        `<li style="padding: 8px 12px; background: #f8f9fa; border-radius: 4px; border-left: 3px solid #9C27B0; margin-bottom: 6px;">${m}</li>`
                    )
                    .join("")
                : '<p style="color: #999; font-style: italic;">Sin información</p>'
            }
          </ul>
        </div>
      </div>

          
      <!-- Proyectos -->
      <div style="background: white; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-left: 4px solid #4CAF50;">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <div style="width: 40px; height: 40px; background: #e8f5e9; border-radius: 50%; 
                      display: flex; align-items: center; justify-content: center; margin-right: 12px;">
            <span style="font-size: 20px;">📊</span>
          </div>
          <h5 style="margin: 0; font-size: 18px; color: #042956; font-weight: 600;">Proyectos</h5>
        </div>
        <div style="max-height: 300px; overflow-y: auto;">
          <ul style="list-style: none; padding: 0; margin: 0;">
            ${
              depto.listaProyectos?.length
                ? depto.listaProyectos
                    .map(
                      (p) =>
                        `<li style="padding: 10px 12px; background: #e8f5e9; border-radius: 4px; border-left: 3px solid #4CAF50; margin-bottom: 8px;">
                          <strong style="color: #2e7d32;">${p.codigo_pre}</strong><br>${p.nombre_proyecto}
                        </li>`
                    )
                    .join("")
                : '<p style="color: #999; font-style: italic;">Sin información</p>'
            }
          </ul>
        </div>
      </div>


        <!-- Grupos territoriales -->
      <div style="background: white; border-radius: 8px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-left: 4px solid #fbc02d;">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <div style="width: 40px; height: 40px; background: #e3f2fd; border-radius: 50%; 
                      display: flex; align-items: center; justify-content: center; margin-right: 12px;">
            <span style="font-size: 20px;">📍</span>
          </div>
          <h5 style="margin: 0; font-size: 18px; color: #042956; font-weight: 600;">Grupos territoriles</h5>
        </div>
        <div style="max-height: 250px; overflow-y: auto;">
          <ul style="list-style: none; padding: 0; margin: 0;">
            ${
              depto.listaGruposTerritoriales?.length
                ? depto.listaGruposTerritoriales
                    .map(
                      (m) =>
                        `<li style="padding: 8px 12px; background: #f8f9fa; border-radius: 4px; border-left: 3px solid #fbc02d; margin-bottom: 6px;">${m}</li>`
                    )
                    .join("")
                : '<p style="color: #999; font-style: italic;">Sin información</p>'
            }
          </ul>
        </div>
      </div>

      
    </div>

    <style>
      div::-webkit-scrollbar { width: 8px; }
      div::-webkit-scrollbar-thumb { background: #4275af; border-radius: 4px; }
      div::-webkit-scrollbar-thumb:hover { background: #042956; }
    </style>

  </div>
`,
    }));

    return {
      status: response.status,
      data: {
        data: processedData, // Asegúrate de que este campo se corresponda con lo esperado por FusionCharts
      },
    };
  } catch (error) {
    console.error("Error al obtener datos del mapa de Colombia:", error);
    throw error; // Lanza el error para ser manejado en el componente React
  }
};

export { getMapColombiaSostenibilidad };
